<div class="lum-c-client-shipping-addresss-accessor">
  <input
    type="text"
    class="lum-input text-ellipsis"
    lumDebounceTime
    [(ngModel)]="selectedItem"
    [matAutocomplete]="auto"
    [placeholder]="'Search for address'"
    [disabled]="loadBusinessAcountShippingAddress$ | async"
    (focus)="onInitialLoadAddresses()"
    (debounceValue)="onChangeEvent($event)"
  />
  <mat-autocomplete
    #auto="matAutocomplete"
    [displayWith]="displayFn"
    (lumInfiniteScroll)="onLazyLoadAddresses()"
  >
    <mat-option
      *ngFor="let option of addresses; trackBy: trackById"
      [value]="option"
      (onSelectionChange)="onSelectItem(option, $event)"
    >
      {{ option.companyName ? option.companyName + ' - ' : ''
      }}{{
        option | addressTransformation: addressTransformationType.CLIENT_SHIPPING
      }}
    </mat-option>
  </mat-autocomplete>
</div>
